import * as React from "react";
import styled from "styled-components";

interface Props {
  title: string;
}

const SBannerWrapper = styled.div`
  margin-left: 10%;
  margin-right: 10%;
  display: flex;
  align-items: center;
  position: relative;
`;

const BalanceText = styled.p`
  font-size: 20px;
  color: #fafafa;
  opacity: 0.7;

  margin: 1em auto;
  text-align: center;
`;

const Description: React.FC<Props> = ({ title }) => {
  return (
    <SBannerWrapper>
      <BalanceText>{title}</BalanceText>
    </SBannerWrapper>
  );
};

export default Description;
